<div class="vincent_about2">
    <div class="row">
        <div class="col col-12 vincent_content">

            <div class="row vincent_reservation xfd">
                <div class="col-lg-6 col-md-6 col-sm-12 vincent_reservation_block ">
                    <h1>{{"enter_your_table_no" | translate}}</h1>
                    <img src="assets/imgs/separator_dark.png" alt="">
                    <p>{{"short_lorem" | translate}}</p>
                    <div class="vincent_form_block ">

                        <form class="vincent_form" #f="ngForm" (ngSubmit)="signup(f)">
                            <div class="row gutters">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <input ngModel name="email" #email="ngModel" type="email" class="form_user-name center" placeholder='{{"email" | translate}}' required email>
                                    <p *ngIf="email.errors?.required && email.touched">{{"please_enter_the_email" | translate}}</p>
                                    <p *ngIf="email.errors?.email && email.touched">{{"please_enter_valid_email" | translate}}</p>
                                </div>
                                
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <input ngModel name="password" #password="ngModel" type="password" class="form_user-name center" placeholder='{{"password" | translate}}' required>
                                        <p *ngIf="password.errors?.required && password.touched">{{"please_enter_your_password" | translate}}</p>
                                </div>
                                
                                <div class="col-lg-6 col-md-6 col-sm-6 left_25">
                                    <input ngModel name="tableno" #tableno="ngModel" type="number" min="0" max="15" class="form_user-name center" placeholder='{{"Table_no" | translate }}' required>
                                    <p *ngIf="tableno.errors?.required && tableno.touched">{{"enter_your_table_no" | translate}}</p>
                                </div>
                    
                            
                            </div>
                            <input type="submit" class="default-btn-one submit" value='{{"submit" | translate}}' [disabled]="f.invalid" *ngIf="submit == true">
                            <div *ngIf="loading == true"> <img src="assets/imgs/loading2.gif" style="width: 40px;"> </div>
                            <div class="alert alert-primary cus" role="alert" *ngIf="errr">
                                {{errr}}
                            </div>
                        </form>

                    </div>
                    <a routerLink="/login">{{"have_an_actuel_account" | translate}}</a>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="logo-side">
                        <img src="assets/imgs/logo.png">
                        <a routerLink="/" class="back-home">{{"back_home" | translate}}</a>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>